var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconChallenges(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.106 12.001A3.104 3.104 0 1112 8.897m7.882 3.104a7.88 7.88 0 11-15.761 0A7.88 7.88 0 0112 4.121m7.762 9.249a7.88 7.88 0 11-6.392-9.13m4.064 7.761a5.433 5.433 0 11-5.433-5.433"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.001 12.001l3.045-3.044-.03-1.642 2.418-2.418v1.671h1.552L16.54 9.016l-1.493-.06"
  }))));
}

export default SvgIconChallenges;